import { FaqActions, FaqActionType } from '@/store/cms/faq/actions';
import { BffCmsFaqResponse, CmsFaqSectionPosition } from '@lucky7ventures/bff-types';

export interface FaqState {
  faq: BffCmsFaqResponse;
  loading: boolean;
  error: boolean;
}

const initialState: FaqState = {
  faq: {
    [CmsFaqSectionPosition.Drawer]: [{ title: '', faqItems: [{ question: '', answer: '' }] }],
    [CmsFaqSectionPosition.Home]: [{ title: '', faqItems: [{ question: '', answer: '' }] }],
  },
  loading: false,
  error: false,
};

export const faqReducer = (state = initialState, action: FaqActions): FaqState => {
  switch (action.type) {
    case FaqActionType.GetFaq:
      return { ...state, loading: true, error: false };
    case FaqActionType.GetFaqError:
      return { ...state, ...initialState, loading: false, error: true };
    case FaqActionType.GetFaqSuccess: {
      return {
        ...state,
        faq: action.faq,
        loading: false,
        error: false,
      };
    }
    default:
      return state;
  }
};
